


























import {
  Component,
  Emit,
  Prop,
  Vue
} from 'vue-property-decorator';

@Component
export default class CookieCategory extends Vue {
  @Prop({required: true})
  public name: string;
  @Prop({required: false, default: false})
  public disabled: boolean;

  @Prop({required: false, default: true})
  public value: boolean;

  @Emit()
  public categoryToggleClicked() {}

  public isExpanded = false;
}
